import type { Huerfano, Movimiento } from "../api/tipos.ts";
import { instanteDe } from "../formato.ts";

/**
 * Los pagos del banco que podrían ser el de un faltante (SPEC-029 §13).
 *
 * Un faltante es un pago que el ERP da por cobrado y que el motor no supo
 * emparejar con nada del banco. Casi siempre la razón es pequeña: el monto
 * difiere un poco (una comisión, un redondeo) o el banco lo dio días después.
 * Así que se ofrecen los pagos que siguen sin decidir, de monto parecido y de
 * fecha cercana, y la persona elige. Nunca se liga solo.
 */
export const DIAS_DE_MARGEN = 10;
export const MARGEN_DE_MONTO = 0.05;
const DIA_MS = 24 * 60 * 60 * 1000;

const sinDecidir = (m: Movimiento) =>
  m.origen === "pendiente" || m.origen === "humano-obsoleto" || m.origen === "clave-ambigua";

export function candidatosDelBanco(h: Huerfano, movimientos: Movimiento[], max = 6): Movimiento[] {
  const monto = h.montoCentavos;
  if (monto === null || monto === undefined) return [];
  const fecha = h.fechaPago ? instanteDe(h.fechaPago) : null;

  const dif = (m: Movimiento) => Math.abs((m.montoCentavos ?? 0) - monto);
  const dias = (m: Movimiento) => (fecha ? Math.abs(instanteDe(m.fecha) - fecha) / DIA_MS : 0);

  return movimientos
    .filter(sinDecidir)
    .filter((m) => m.montoCentavos !== null && dif(m) <= monto * MARGEN_DE_MONTO)
    .filter((m) => !fecha || dias(m) <= DIAS_DE_MARGEN)
    .sort((a, b) => dif(a) - dif(b) || dias(a) - dias(b))
    .slice(0, max);
}
